import { DISPLAY_LOADER } from "../reducerConstants";

const initialState = {
  loading: false
};

const LoaderReducer = (state = initialState, action = {}) => {
  const { type, data } = action;
  switch (type) {
    case DISPLAY_LOADER:
      return {
        ...state,
        loading: data
      };
    default:
      return state;
  }
};

export default LoaderReducer;
